/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class QprecoInterestsAPI extends ApiClient {
  constructor() {
    super('qpreco_interests', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  detailed(id, params = {}) {
    const encodedId = encodeURIComponent(id);
    return axios.get(
      withQuery(resourcePath(this.url, encodedId, 'detailed'), params),
      requestConfig()
    );
  }

  report(id, params = {}) {
    const encodedId = encodeURIComponent(id);
    return axios.get(
      withQuery(resourcePath(this.url, encodedId, 'report'), params),
      requestConfig()
    );
  }

  shares(id) {
    const encodedId = encodeURIComponent(id);
    return axios.get(
      resourcePath(this.url, encodedId, 'shares'),
      requestConfig()
    );
  }

  createShare(id, payload = {}) {
    const encodedId = encodeURIComponent(id);
    return axios.post(
      resourcePath(this.url, encodedId, 'shares'),
      { share: payload },
      requestConfig()
    );
  }

  revokeShare(id, shareId, payload = {}) {
    const encodedId = encodeURIComponent(id);
    const encodedShareId = encodeURIComponent(shareId);
    return axios.post(
      resourcePath(this.url, encodedId, 'shares', encodedShareId, 'revoke'),
      { share: payload },
      requestConfig()
    );
  }

  syncPriceHistories() {
    return axios.post(
      resourcePath(this.url, 'sync_price_histories'),
      {},
      requestConfig()
    );
  }

  create(payload) {
    return axios.post(this.url, { qpreco_interest: payload }, requestConfig());
  }

  update(id, payload) {
    return axios.patch(
      resourcePath(this.url, id),
      { qpreco_interest: payload },
      requestConfig()
    );
  }

  delete(id) {
    return axios.delete(resourcePath(this.url, id), requestConfig());
  }
}

export default new QprecoInterestsAPI();
